import { initials } from '@/shared/lib/contact'
import { cls } from '@/ui/cls'
type Tone = 'yellow' | 'muted' | 'neutral'

interface Props {
  name: string
  size?: number
  tone?: Tone
  title?: string
}

const TONE_CLASSES: Record<Tone, string> = {
  yellow: 'bg-brand text-ink-1000',
  muted: 'bg-ink-100 text-ink-700',
  neutral: 'bg-ink-1000 text-paper',
}

export default function Avatar({ name, size = 28, tone = 'neutral', title }: Props) {
  return (
    <span
      className={cls(
        'inline-grid place-items-center rounded-full font-semibold shrink-0',
        TONE_CLASSES[tone],
      )}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      title={title}
    >
      {initials(name)}
    </span>
  )
}
